export enum TranslationsKeys {
  TERMS = 'terms',
  OLD_TRANSLATIONS = 'translation',
  AUTH_REGISTER = 'auth/register',
}

export const TranslatonsArray = Object.values(TranslationsKeys);
